module.exports = __webpack_public_path__ + "img/restaurant-demo-600x450.b7f675f5.jpg";